import { gql } from '@apollo/client';
import { forPaginated } from './common/paginated.graphql';
import { Asset } from '../types/asset/asset';
import { CreateAssetInput, UpdateAssetInput } from '../types/asset/asset.input';
import { AssetTransactionFragment } from './assetTransaction.graphql';
import { AssetTransaction } from '../types/asset_transaction/assetTransaction';

const asset = gql`
  fragment Asset on Asset {
    id
    version
    companyId
    createdAt
    createdBy
    updatedAt
    updatedBy
    identifier
    location {
      entityId
      entityType
    }
    product {
      productMasterDataId
      serial
      quantity
      unitQuantity
      customFields {
        id
        name
        type
        value
        mandatory
        generated
      }
    }
  }
`;

const get = gql`
  query Assets($page: Float) {
    assets(page: $page) {
      data {
        ...Asset
      }
      page
      pageSize
      batchSize
      hasNext
    }
  }
  ${asset}
`;

export interface GetAssetsVariables {
  page?: number;
}

export interface GetAssetsResponse {
  assets: PaginatedAssets;
}

class PaginatedAssets extends forPaginated<Asset>() {}

const create = gql`
  mutation CreateAsset($assets: [CreateAssetInput!]!) {
    createAsset(assets: $assets) {
      ...AssetTransaction
    }
  }
  ${AssetTransactionFragment.assetTransaction}
`;

export interface CreateAssetVariables {
  assets: CreateAssetInput[];
}

export interface CreateAssetResponse {
  createAsset: AssetTransaction[];
}

const update = gql`
  mutation UpdateAsset($assets: [UpdateAssetInput!]!) {
    updateAsset(assets: $assets) {
      ...Asset
    }
  }
  ${asset}
`;

export interface UpdateAssetVariables {
  assets: UpdateAssetInput[];
}

export interface UpdateAssetResponse {
  updateAsset: Asset[];
}

export const AssetQueries = {
  get,
};

export const AssetMutations = {
  create,
  update,
};

export const AssetFragment = {
  asset,
};
